<template>
  <ModalOperator text="当前岗位" title="当前岗位" type="primary" iconType="md-contact" iconSize="18">
    <zpa-form ref="Form">
      <zpa-form-group>
        <zpa-select v-model="id" textField="valueField" valueField="userUnitId" label="下拉框" :query="queryPositions">
          <template slot-scope="{row}">
            {{row.valueField}}
          </template>
        </zpa-select>
      </zpa-form-group>
    </zpa-form>
  </ModalOperator>
</template>
<script>
import ModalOperatorMixin from '@/components/commons/ModalOperatorMixin'
import {queryPositions, getCurrposition, setPosition} from '@/api/login'
export default {
  name: 'UserRank',

  mixins: [
    ModalOperatorMixin,
  ],

  data() {
    return {
      id: '',
    }
  },
  computed: {

  },
  methods: {
    queryPositions,
    async beforeOpen() {
      let _currentuser = await getCurrposition()
      this.id = _currentuser.userUnitId
    },
    onSubmit() {
      return setPosition(this.id)
    },
  },
}
</script>
